import React, { useState, useEffect } from 'react'
import { MDBInput } from 'mdbreact';
import axios from 'axios'
import { errores } from '../hooks/Funciones'
import moment from 'moment'

import ReactMoment from 'react-moment';
import { jsonrepair } from 'jsonrepair';


const getRandomInt = (max) => {
	return Math.floor(Math.random() * max);
}

const SubirUsuario = ({ baseUrl, data, setData, setFuncion, Cursos, funcion, registroSelect, urlPedidos, dataFiltrado, setDataFiltrado }) => {
	//errores

	const APLICACION = process.env.REACT_APP_NAME_APP
	const [error, setError] = useState({ activo: '' })
	const [claveNueva, setClaveNueva] = useState('')
	const [cursosPedidos, setCursosPedidos] = useState([])

	const [registro, setRegistro] = useState(
		funcion === 'editar' ?
			{ ...registroSelect, tel: registroSelect.telefono, cursos: JSON.parse(registroSelect.cursos) } :
			{ cursos: [], fecha_cad: moment(new Date()).format("YYYY-MM-DD"), activo: 'Aprobado' }
	)


	const [startDate, setStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"));

	const [cursosActuales, setCursosActuales] = useState([])
	const [pedidosOriginales, setPedidosOriginales] = useState([])


	const estaonoArray = (dato) => {
		let array = registro.cursos
		let result = false
		array.map(item => { if (item === dato) { result = true } })
		return result
	}

	const subeCursos = (id) => e => {

		console.log('id', id)
		let array = registro.cursos
		if (estaonoArray(id)) {
			let index = array.indexOf(id);
			if (index > -1) { array.splice(index, 1); }
		} else { array = [...array, id] }

		setRegistro({ ...registro, cursos: array })


	}


	const cambiarCheckCurso = (id_curso, check, item) => {

		console.log('cambiarCheckCurso', id_curso, check)

		let cursosActualesArray = []
		cursosActuales.map((curso) => {
			if (curso.id_curso === id_curso) {
				return cursosActualesArray.push({ ...curso, checked: check, virtual: true })
			}

			return cursosActualesArray.push(curso)
		})
		setCursosActuales(cursosActualesArray)
	}

	useEffect(() => { cargarCursos() }, [])

	const cargarCursos = async () => {

		const urlPedidos = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + 'pedidos/'
		const consultarPedidosUsuario = await axios.get(urlPedidos, { params: { tipo: 'personalizada', id: registro.usuario } })
		const resultadoPedidos = consultarPedidosUsuario.data;

		const pedidosArray = []
		resultadoPedidos && resultadoPedidos.map((pedido) => {

			const pedidos = JSON.parse(jsonrepair(pedido.pedido))
			pedidos.map(item => {
				if (pedido.id) {
					item['id_pedido'] = pedido.id;
					item['fecha'] = pedido.fecha;
					pedidosArray.push(item)
				} else {
					pedidosArray.push(item)
				}
			})
		})
		setCursosPedidos(resultadoPedidos)
		const cursosVirtuales = []
		const cursosOriginales = []
		Cursos.map((curso) => {
			const pedido = pedidosArray.find(item => item.id_curso == curso.id)
			const pedidoVirtual = pedidosArray.some((pedido) => pedido.id_curso === curso.id && pedido.id_pedido == registro.temp)

			if (!pedido || pedidoVirtual || funcion === 'crear') {
				let cursoPedido = {
					"id": getRandomInt(300),
					"activo": curso.activo,
					"tipo": "Curso",
					"nombre_producto": curso.nombre,
					"precio_producto": "0.00",
					"precio_rebajado": "0.00",
					"impuesto_producto": "Taxes",
					"categoria_producto": ["Todo", "cursos"],
					"atributos": [],
					"url_imagen": [{ "nombre_imagen": curso.imagen }],
					"id_curso": curso.id,
					"descripcion": curso.descripcion,
					"carga": 0,
					"cantidad": 1,
					"sumaImp": 0,
					"checked": pedidosArray.some((pedido) => pedido.id_curso === curso.id),
					"existe": pedidosArray.some((pedido) => pedido.id_curso === curso.id),
					"id_pedido": pedido ? pedido.id_pedido : null,
					"virtual": pedidosArray.some((pedido) => pedido.id_curso === curso.id && pedido.id_pedido == registro.temp)
				}
				cursosVirtuales.push(cursoPedido)
			} else {
				cursosOriginales.push(pedido)
			}
		})
		setPedidosOriginales(cursosOriginales)
		setCursosActuales(cursosVirtuales)
	}

	//Comprueba si existe un usuario antes de guardarlo
	const existeUsuario = user => {
		let resultado = false
		data.map((item) => {
			let { usuario } = item
			if (usuario === user)
				resultado = true
		})
		return resultado
	}

	const subeUsuario = async (idPedidoVirtual) => {

		let { activo, usuario, clave, roll, nombre, email, pais, ciudad, estado, telefono, cursos } = registro

		let fechaCad = moment(registro.fecha_cad).format("YYYY-MM-DD HH:mm:ss")
		const fechaHoy = moment(new Date()).format("YYYY-MM-DD");

		let f = new FormData()
		f.append('activo', activo)
		f.append('usuario', usuario !== '' ? usuario.trim() : '')
		f.append('clave', clave)
		f.append('roll', roll)
		f.append('nombre', usuario !== '' ? nombre.trim() : '')

		f.append('fecha_ins', fechaHoy)
		f.append('fecha_cad', fechaCad)
		f.append('pais', pais !== '' ? pais.trim() : '')
		f.append('ciudad', ciudad !== '' ? ciudad.trim() : '')
		f.append('estado', estado !== '' ? estado.trim() : '')
		f.append('telefono', telefono !== '' ? telefono.trim() : '')
		f.append('email', email !== '' ? email.trim() : '')
		f.append('cursos', JSON.stringify(cursos))
		f.append('puntos', 0)
		f.append('id_stripe', ' ')
		f.append('temp', idPedidoVirtual)
		f.append('METHOD', 'POST')
		await axios.post(baseUrl, f)

			.then(response => {
				setData([response.data, ...data])
				setDataFiltrado([response.data, ...dataFiltrado])
				//setDataFiltrado(dataFiltrado.concat(response.data))
				console.log('user OK');
				setRegistro({})
				errores('Limpio', setError)
				setFuncion('ver')
			}).catch(error => {
				console.log(error);
			})
	}

	//Consulta para subir o crear los datos 
	const peticionPost = async () => {

		let { activo, usuario, clave, roll, nombre, pais, email, ciudad, estado, telefono, cursos } = registro
		const pedido = cursosActuales.filter(curso => curso.checked && !curso.existe)

		if (activo !== undefined && usuario !== undefined && clave !== undefined && nombre !== undefined && roll !== undefined && email !== undefined && pais !== undefined && ciudad !== undefined && estado !== undefined && telefono !== undefined) {
			if (pedido.length > 0) {
				if (!existeUsuario(usuario)) {
					let idPedidoVirtual = ' ';
					const datosPago = {
						"subtotal": "0",
						"taxes": 0,
						"totalCargas": 0,
						"cargas": 0,
						"porcentajeImpuesto": 0,
						"total": "0",
						"canal": 'Activacion'
					}
					let formData = new FormData()
					formData.append('pedido', JSON.stringify(pedido))
					formData.append('datosPago', JSON.stringify(datosPago))
					formData.append('estado', "Aprobado")
					formData.append('total', "0")
					formData.append('cliente', JSON.stringify(registro))
					formData.append('id_stripe', " ")
					formData.append('usuario', registro.usuario)
					formData.append('fecha', moment().format("YYYY-MM-DD h:mm:ss"))
					formData.append('METHOD', 'POST')

					await axios.post(urlPedidos, formData)

						.then(response => {
							idPedidoVirtual = response.data.id
							console.log('pedido OK')
							subeUsuario(idPedidoVirtual)
						}).catch(error => {
							console.log(error);
						})
				} else errores('Existe', setError)
			} else errores('Curso', setError)
		} else errores('CampoVacio', setError)
	}

	const peticionPut = async () => {

		console.log('cursosActuales', cursosActuales)

		let fechaCad = moment(registro.fecha_cad).format("YYYY-MM-DD HH:mm:ss")
		const fechaHoy = moment(new Date()).format("YYYY-MM-DD");
		let { id, activo, usuario, clave, roll, nombre, email, pais, ciudad, estado, telefono, puntos, cursos } = registro

		if (usuario !== undefined && clave !== undefined && nombre !== undefined && roll !== undefined && email !== undefined && pais !== undefined && ciudad !== undefined && estado !== undefined && telefono !== undefined) {
			let f = new FormData()
			f.append('activo', activo)
			f.append('usuario', usuario.trim())
			f.append('clave', clave)
			f.append('claveNueva', claveNueva)
			f.append('roll', roll)
			f.append('nombre', nombre.trim())

			f.append('fecha_ins', fechaHoy)
			f.append('fecha_cad', fechaCad)
			f.append('pais', pais.trim())
			f.append('ciudad', ciudad.trim())
			f.append('estado', estado)
			f.append('telefono', telefono.trim())
			f.append('email', email.trim())
			f.append('cursos', JSON.stringify(cursos))
			f.append('puntos', puntos)
			f.append('METHOD', 'PUT')
			await axios.post(baseUrl, f, { params: { id: registro.id } })


				.then(response => {
					let dataNueva = data
					dataNueva.map(item => {
						if (item.id === id) {
							item.activo = activo
							item.usuario = usuario
							item.clave = response.data.clave
							item.roll = roll
							item.nombre = nombre
							item.telefono = telefono
						}
					})

					setData(dataNueva)
					setRegistro({ activo: false })
					errores('Limpio', setError)
					setClaveNueva('')
					setFuncion('ver')
				}).catch(error => {
					console.log(error);
				})



			console.log('acaaa')
			const urlPedidos = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + 'pedidos/'
			const pedido = cursosActuales.filter(curso => curso.checked)
			//actualizar pedido
			if (registro.temp) {
				let formData = new FormData()
				formData.append('pedido', JSON.stringify(pedido))
				formData.append('id', registro.temp)
				formData.append('METHOD', 'PUT')

				return await axios.post(urlPedidos, formData)
			} else {
				let idPedidoVirtual = ' ';
				const urlPedidos = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + 'pedidos/'
				const pedido = cursosActuales.filter(curso => curso.checked && !curso.existe)

				const datosPago = {
					"subtotal": "0",
					"taxes": 0,
					"totalCargas": 0,
					"cargas": 0,
					"porcentajeImpuesto": 0,
					"canal": 'Activacion',
					"total": "0"
				}
				let formData = new FormData()
				formData.append('pedido', JSON.stringify(pedido))
				formData.append('datosPago', JSON.stringify(datosPago))
				formData.append('estado', "Aprobado")
				formData.append('total', "0")
				formData.append('cliente', JSON.stringify(registro))
				formData.append('id_stripe', " ")
				formData.append('usuario', registro.usuario)
				formData.append('fecha', moment().format("YYYY-MM-DD h:mm:ss"))
				formData.append('METHOD', 'POST')

				const resultado = await axios.post(urlPedidos, formData)


				idPedidoVirtual = resultado.data.id
				let f = new FormData()

				f.append('temp', idPedidoVirtual)
				f.append('id', registro.id)
				f.append('METHOD', 'PUT')

				return await axios.post(baseUrl, f)
			}

		} else errores('CampoVacio', setError)

	}
	return (
		<div>
			<div className="row">
				<div className="col-md-12">
					{error.activo ?
						<span className="error"> Error: {error.mensaje}</span> : null
					}
					<div><hr />



						<div className='row '>
							<div className='col-md-4'>
								<div className={`estados ${registro.activo}`} style={{ marginTop: 8 }}>
									{registro.activo}
								</div>
							</div>
							<div className='col-md-4'>
								<select className="browser-default custom-select selectEstado"
									name="estado"
									value={registro.activo}
									onChange={e => setRegistro({ ...registro, activo: e.target.value })}>
									<option value="Aprobado">Aprobado</option>
									<option value="Pendiente">Pendiente</option>
									<option value="Incompleto">Incompleto</option>
									<option value="Fallido">Fallido</option>
								</select>
							</div>
							<div className='col-md-4 sinMargen'>
								<MDBInput
									style={{ marginTop: 5, marginBottom: 0 }}
									label="Puntos" name="puntos" className="disabled sinMargen" outline
									value={registro.puntos}
									onChange={e => setRegistro({ ...registro, puntos: e.target.value })}
								/>
							</div>
							<div className='col-md-6'>
								<MDBInput
									label="Nombre Completo del Usuario" name="nombre" required className={error.campoNombreUser ? "form-control is-invalid" : null} outline
									value={registro.nombre}
									onChange={e => setRegistro({ ...registro, nombre: e.target.value })}
								/>

							</div>
							<div className='col-md-6'>
								<MDBInput
									label="E-mail" name="email" required className={error.campoNombreUser ? "form-control is-invalid" : null} outline
									value={registro.email}
									onChange={e => setRegistro({ ...registro, email: e.target.value })}
								/>

							</div>
						</div>

						<div className='row sinMargen'>
							<div className='col-md-6'>
								<MDBInput name="usuario" required className={error.campoUsuario ? "form-control is-invalid" : null} outline
									label={'Usuario'}
									value={registro.usuario}
									onChange={e => setRegistro({ ...registro, usuario: e.target.value })}
								/>
							</div>
							<div className='col-md-6'>
								{funcion === 'editar' ?
									<MDBInput label="Clave nueva" type="password" name="clave" required className={error.campoClave ? "form-control is-invalid" : null} outline
										value={claveNueva}
										onChange={e => setClaveNueva(e.target.value)}
									/>
									:
									<MDBInput label={funcion === 'editar' ? "Clave nueva" : "Clave"} type="password" name="clave" required className={error.campoClave ? "form-control is-invalid" : null} outline
										value={registro.clave}
										onChange={e => setRegistro({ ...registro, clave: e.target.value })}
									/>
								}
							</div>
						</div>

						<div className='row sinMargen'>
							<div className='col-md-4'>
								<MDBInput name="Pais" required className={error.campoUsuario ? "form-control is-invalid" : null} outline
									label={'País'}
									value={registro.pais}
									onChange={e => setRegistro({ ...registro, pais: e.target.value })}
								/>

							</div>
							<div className='col-md-4'>
								<MDBInput name="Estado" required className={error.campoUsuario ? "form-control is-invalid" : null} outline
									label={'Estado / Departamento'}
									value={registro.estado}
									onChange={e => setRegistro({ ...registro, estado: e.target.value })}
								/>

							</div>
							<div className='col-md-4'>
								<MDBInput name="Ciudad" required className={error.campoUsuario ? "form-control is-invalid" : null} outline
									label={'Ciudad'}
									value={registro.ciudad}
									onChange={e => setRegistro({ ...registro, ciudad: e.target.value })}
								/>
							</div>
						</div>

						<div className='row sinMargen'>
							<div className='col-md-4'>
								<MDBInput name="Telefono" required className={error.campoUsuario ? "form-control is-invalid" : null} outline
									label={'Teléfono'}
									value={registro.telefono}
									onChange={e => setRegistro({ ...registro, telefono: e.target.value })}
								/>
							</div>
							<div className='col-md-4'>
								<div>

									<select
										className={error.campoRoll ? "form-control is-invalid browser-default custom-select selectAtri" : "browser-default custom-select selectAtri"} name="roll"
										value={registro.roll}
										onChange={e => setRegistro({ ...registro, roll: e.target.value })}>
										<option value="">Selecciona Rol</option>
										<option value="Admin">Admin</option>
										<option value="Master">Master</option>
										<option value="Comercial">Comercial</option>
										<option value="Estudiante">Estudiante</option>
									</select>

									<br />
								</div>
							</div>
							<div className='col-md-4'>
								<div className='row'>
									<div className='col-md-3'>
										<span style={{ fontSize: 13 }}><b>Caducidad: </b></span>
									</div>
									<div className='col-md-9'>
										<input className='form-control'
											type="date"
											value={registro.fecha_cad}
											onChange={(text) => setRegistro({ ...registro, fecha_cad: text.target.value })}

										/>
									</div>

								</div>
							</div>
						</div>

						{APLICACION !== 'BLUEMOON' ?
							<div className='col-md-12'>
								<div>
									<h5>Seleccione Cursos:</h5>
									{Cursos.map((item, index) => {
										if (item.activo === 'true') {
											return (
												<div className="custom-control custom-checkbox custom-control-inline" key={index}>
													<input type="checkbox" className="custom-control-input" name={item.id} id={item.nombre}
														onChange={subeCursos(item.id)} checked={estaonoArray(item.id)} />
													<label className="custom-control-label" htmlFor={item.nombre}>{item.nombre}</label>
												</div>
											)
										}
									})
									}
								</div>
							</div>
							:
							<>
								{funcion === 'crear' && <div className='col-md-12'>
									<div>
										<h5>Seleccione Cursos:</h5>
										{cursosActuales.map((item, index) => {
											if (item.activo === 'true') {
												return (
													<div className="custom-control custom-checkbox custom-control-inline" key={index}>
														<input type="checkbox" className="custom-control-input" name={item.id_curso} id={item.nombre_producto}
															onChange={(e) => cambiarCheckCurso(item.id_curso, e.target.checked, item)} checked={item.checked} />
														<label className="custom-control-label" htmlFor={item.nombre_producto}>{item.nombre_producto}</label>
													</div>
												)
											}
										})
										}
									</div>
								</div>}

								{funcion === 'editar' && cursosActuales.length > 0 && <div className='col-md-12'>
									<div>
										<h5>Seleccione Cursos:</h5>
										{cursosActuales.map((item, index) => {
											if (item.activo === 'true') {
												return (
													<div className="custom-control custom-checkbox custom-control-inline" key={index}>
														<input type="checkbox" className="custom-control-input" name={item.id_curso} id={item.nombre_producto}
															onChange={(e) => cambiarCheckCurso(item.id_curso, e.target.checked, item)} checked={item.checked} />
														<label className="custom-control-label" htmlFor={item.nombre_producto}>{item.nombre_producto}</label>
													</div>
												)
											}
										})
										}
									</div>
								</div>}

								{funcion === 'editar' && pedidosOriginales.length > 0 &&
									<>
										<hr />
										<div className='col-md-12 editar-usuario'>
											<div className='editar-usuario-comprados'>
												<h5>Cursos Comprados:</h5>
												{pedidosOriginales.map((pedido) =>
													<div className='editar-usuario-comprados-container' key={pedido.id}>

														<div className='editar-usuario-comprados-container-items'>
															<div className='editar-usuario-comprados-container-items-item'>
																<p><ReactMoment format="YYYY-MM-DD">
																	{pedido.fecha}
																</ReactMoment></p> <p>|</p> <p className='titulo'>{pedido.nombre_producto}</p>
															</div>
															<div className='editar-usuario-comprados-container-items-item mr60'>
																<p>Factura:</p> <p className='titulo'>{pedido.id_pedido}</p>
															</div>
														</div>
													</div>
												)}
											</div>
										</div>
									</>
								}

							</>
						}

						<br />
						<div className="col text-center">
							<button
								onClick={funcion === 'editar' ? peticionPut : peticionPost}
								className="btn boton_estandar"
							>{`Subir Usuario`}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default SubirUsuario